export class JobMatchQueryFilter {
    constructor() {
        this.candidateId = "";
        this.userId = "";
        this.companyId = "";
        this.top5Flag = true;
        this.candidateType = "";
        this.searchText = "";
        this.vendorIds = [];
    }
}
//# sourceMappingURL=jobMatchQueryFilter.js.map